import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormControl } from '@material-ui/core';
import { ModalActionsComponent, PasslySelect, PasslyTextField } from '@app/components';
import { getLoaderBtn, getModalSwitch } from '@app/store/actions';
import { vaultPasswordsService } from '@app/services';
import { useTypedTranslation } from '@app/hooks';
import { onPressEnterModal, provisioningStatesSimple, disabled } from '@app/helpers';
import { confirm } from '@app/components/Modal/confirmModal';

export interface IReceivedData {
    id: string;
    agentName: string;
    status: string;
    editAgentCompleteCallback: Function;
}

export default function EditPwsAgentDialog(props: IReceivedData) {
    const [agentNameInvalid, setAgentNameInvalid] = useState(false);
    const [agentName, setAgentName] = useState(props.agentName);
    const [agentStatusSelected, setAgentStatusSelected] = useState(props.status);
    const [errorMessage, setErrorMessage] = useState('');

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const onFormChange = (e: any) => {
        const { name, value } = e.target;

        switch (name) {
            case 'agentName':
                setAgentName(value);
                break;
            case 'agentStatusSelected':
                setAgentStatusSelected(value);
                break;
        }
    };

    const onAgentNameChange = (e: any) => {
        const displayName: string = e.target.value;

        if (displayName === '') {
            setAgentNameInvalid(true);
        }
        else {
            setAgentNameInvalid(false);
        }

        onFormChange(e);
    };

    const handlePatchError = (error: any) => {
        dispatch(getLoaderBtn(false));
        if (error.response.status === 409) {
            setErrorMessage(translation('INVALID_TAKEN_AGENT_NAME'));
        }
        else {
            setErrorMessage(translation('EDIT_AGENT_ERROR'));
        }
    };

    const handleSubmitBtn = () => {
        if (agentStatusSelected === disabled) {
            dispatch(getLoaderBtn(false));

            confirm(
                translation('CONFIRM_DISABLE_AGENT_MESSAGE'),
                translation('DISABLE_BUTTON'),
                translation('CANCEL'),
                '',
                true)
                .then(() => {
                    handleUpdate();
                },
                    () => {
                        // cancel
                        handleCancel();
                    }
                );

            return;
        }
        else {
            handleUpdate();
        }
    };

    const handleUpdate = () => {
        dispatch(getLoaderBtn(true));

        let jsonObject: any = {};
        jsonObject.Id = props.id;
        jsonObject.AgentName = agentName;
        jsonObject.ProvisioningState = agentStatusSelected;
        jsonObject.StatusAction = 'Provisioned';

        vaultPasswordsService.patchSyncAgent(jsonObject, props.id, handleClose, handlePatchError);
    };

    const handleClose = () => {
        dispatch(getLoaderBtn(false));
        props.editAgentCompleteCallback(agentName, agentStatusSelected);
    };

    const handleCancel = () => {
        dispatch(getLoaderBtn(false));
        dispatch(getModalSwitch(false));
    };

    return (
        <>
                <form className='modal__form' method='post' tabIndex={0} onKeyPress={onPressEnterModal(handleSubmitBtn, agentNameInvalid)}>
                    <FormControl>
                        <PasslyTextField
                            fullWidth
                            error={agentNameInvalid}
                            name='agentName'
                            value={agentName}
                            onChange={onAgentNameChange}
                            id='agentName-input'
                            helperText={agentNameInvalid ? translation('REQUIRED_FIELD') : ''}
                            label={translation('AGENT_NAME')}
                            autoFocus
                        />
                    </FormControl>

                    <FormControl>
                        <PasslySelect
                            name='agentStatusSelected'
                            value={agentStatusSelected}
                            onChange={onFormChange}
                            id='select-input'
                            label={'AGENT_STATE'}
                            options={provisioningStatesSimple}
                        />
                    </FormControl>

                    {errorMessage !== '' &&
                        <p><div className='modal__error'>{errorMessage}</div></p>
                    }
                </form>
                <ModalActionsComponent
                    primaryBtn={translation('SAVE_CHANGES')}
                    secondaryBtn={translation('CANCEL')}
                    onClickPrimary={handleSubmitBtn}
                    onClickSecondary={handleCancel}
                    disabled={agentNameInvalid}
                    id='editPwsAgent'
                />
        </>
    );
}
